import { CustomerDocumentType, CustomerFields } from "models/customer/types";
import {
	AddressFields,
	EstablishmentFields,
	PartnerFields
} from "models/partner/types";
import { TenantFields, TermFields } from "models/tenant/types";
import {
	EditTenant,
	NewTenant,
	PartnerList,
	TenantDetails,
	TenantList
} from "pages/backoffice";
import CustomerDetails from "pages/backoffice/Customer/Details";
import CustomerList from "pages/backoffice/Customer/List";
import PartnerDetails from "pages/backoffice/Partner/Details";
import { Tab, Tabs } from "utils/types";

export namespace Constants {
	export const loginStatus = [
		{ label: 401, value: "Login/Senha inválidos" },
		{ label: 502, value: "OPS! Ocorreu algum problema, tente novamente." }
	];
	export const frontendURL = process.env.REACT_APP_FRONTEND_URL || "";
	export const strings = {
		general: {
			tenants: "Produtos",
			partners: "Parceiros",
			customers: "Clientes",
			status: { inactive: "Inativo", active: "Ativo" },
			steps: "Passos",
			of: "de"
		},
		pages: {
			notFound: {
				subtitle: "Parece que essa página foi removida ou não existe",
				title: "Página não encontrada"
			},
			listing: {
				tenant: {
					headers: {
						product: "Produto",
						type: "Plataforma",
						cnpj: "CNPJ",
						productionLink: "Link de produção",
						homologLink: "Link de homologação"
					}
				},
				partners: {
					headers: {
						partner: "Parceiro",
						tenant: "Produto",
						cnpj: "CNPJ",
						city: "Cidade",
						state: "UF",
						status: "Status"
					}
				},
				customers: {
					customerData: "Informações do cliente",
					headers: {
						partner: "Cliente",
						name: "Nome",
						legalName: "Razão Social",
						cpf: "CPF",
						cnpj: "CNPJ",
						email: "Email",
						contactPhone: "Telefone"
					}
				},
				term: {
					headers: {
						fileName: "Nome do arquivo",
						activationDate: "Data de ativação",
						status: "Status"
					},
					statusType: {
						active: "Ativo",
						inactive: "Inativo",
						scheduled: "Agendado"
					}
				},
				messages: {
					error: "Não foi possível exibir os dados",
					noData: "Nenhum dado para exibir"
				},
				pagination: "Linhas por página"
			},
			newTenant: {
				newProduct: "Novo Produto",
				name: "Nome",
				tenantData: "Dados do produto",
				accessLinks: "Links de acesso",
				productName: "Nome produto",
				description: {
					label: "Descrição",
					placeholder: "Descrição do produto"
				},
				tenantType: {
					label: "Plataforma",
					placeholder: "ex: WebApp, App..."
				},
				url: {
					label: "Produção"
				},
				homologUrl: {
					label: "Homologação"
				},
				backofficeUrl: {
					label: "Backoffice"
				},
				addNewLink: "Adicionar outro link",
				linkType: "Tipo de link",
				link: "Link"
			},
			term: {
				addTerm: "Adicionar termo",
				updateTerm: "Atualizar termo",
				editTerm: "Editar termo",
				modalTitle: "Deseja excluir o agendamento do termo?",
				warningMessage: "Esta ação não poderá ser desfeita.",
				label: "Dados do termo",
				uniqueOption: "Somente um termo está disponível para seleção.",
				termType: {
					label: "Tipo de termo",
					placeholder: "Selecione termo"
				},
				termDate: {
					label: "Data de publicação",
					placeholder: "DD/MM/AAAA"
				}
			},
			login: {
				getInto: "Entrar",
				access: "Acesse o sistema com o seu email corporativo.",
				continueMicrosoft: "Continuar com Microsoft"
			},
			userNotFound: {
				email: "Email não cadastrado",
				permission:
					"Você não tem permissão para acessar o backoffice de Plataformas",
				requestCCR:
					"Solicite o acesso para a pessoa gestora da sua área de trabalho dentro do grupo CCR."
			}
		},
		inputs: {
			cancel: "Cancelar",
			search: "Buscar",
			add: "Adicionar",
			edit: "Editar",
			exclude: "Excluir agendamento",
			requiredField: "Este campo é obrigatório",
			register: "Cadastrar",
			update: "Atualizar",
			save: "Salvar",
			select: "Selecione",
			optionalField: "Opcional",
			proceed: "Prosseguir",
			noAvailableOptions: "Não há opções",
			files: {
				attachmentProgressMessage: (uploadProgress: number) =>
					`Anexando documento: ${uploadProgress}% concluído`,
				documentAttached: "Termo anexado",
				successfulAttachment: "Completo"
			},
			errors: {
				invalidPostalCode: "CEP no formato 00000-000 inválido",
				invalidNumber: "Número inválido",
				invalidUrlFormat: (expectedFormat: string) =>
					`URL no formato inválido. Formato esperado: ${expectedFormat}`,
				invalidEmail: "Email inválido."
			}
		},
		fields: {
			[TenantFields.ID]: "ID",
			[TenantFields.TYPE]: "Plataforma",
			[TenantFields.TYPE_ID]: "ID da Plataforma",
			[TenantFields.DESCRIPTION]: "Descrição",
			[TenantFields.URL]: "Produção",
			[TenantFields.HOMOLOGATION]: "Homologação",
			[TenantFields.BACKOFFICE]: "Backoffice",
			[TermFields.TERM_TYPE]: "Tipo do termo",
			[TermFields.FILE]: "Arquivo",
			[TermFields.DATE]: "Data da ativação",
			[PartnerFields.LOGO_URL]: "Logo",
			[PartnerFields.ESTABLISHMENT_IMAGE_URL]: "Foto / Imagem",
			[EstablishmentFields.TRADE_NAME]: "Nome fantasia",
			[EstablishmentFields.CONTACT_PHONE]: "Telefone do Estabelecimento",
			[AddressFields.POSTAL_CODE]: "CEP",
			[AddressFields.STREET]: "Logradouro",
			[AddressFields.CITY]: "Cidade / UF",
			[EstablishmentFields.SITE_URL]: "Link 1",
			[EstablishmentFields.LEGAL_NAME]: "Razão Social",
			[EstablishmentFields.IE]: "Inscrição Estadual",
			[EstablishmentFields.RESPONSIBLE_NAME]: "Nome",
			[EstablishmentFields.RESPONSIBLE_CPF]: "CPF",
			[EstablishmentFields.RESPONSIBLE_PHONE]: "Telefone do responsável",
			[EstablishmentFields.RESPONSIBLE_ROLE]: "Função",
			[EstablishmentFields.REMARK]: "Observação",
			[CustomerFields.LEGAL_NAME]: "Razão Social",
			[CustomerDocumentType.CPF]: "CPF",
			[CustomerDocumentType.CNPJ]: "CNPJ",
			[CustomerFields.EMAIL]: "Email",
			phone: "Telefone",
			cnpj: "CNPJ",
			name: "Nome",
			establishmentData: "Dados do estabelecimento",
			establishment: "Estabelecimento",
			taxData: "Dados fiscais",
			responsibleData: "Dados do responsável pelo estabelecimento",
			addNewLink: "Adicionar link",
			customerInfo: "Informações do cliente"
		},
		errors: {
			startDateError: "A data de início não pode ser anterior à data atual.",
			maxDateError: "Selecione uma data válida.",
			error: "Erro",
			somethingWentWrong: "OPS! Alguma coisa deu errado. Tente novamente.",
			conectionError: "Ocorreu um erro de conexão. Tente novamente.",
			conectionFailed: "Falha na conexão, tente novamente em alguns instantes",
			failedToGetTenantTypes:
				"Falha ao buscar tipos de Plataforma. Recarregue a página.",
			failedToGetTermTypes:
				"Falha ao buscar tipos de termos. Recarregue a página.",
			failedToGetTenantDetails:
				"Falha ao buscar detalhes do Produto. Retornando à listagem.",
			failedToGetPartnerDetails:
				"Falha ao buscar detalhes do Parceiro. Retornando à listagem.",
			failedToGetCustomerDetails:
				"Falha ao buscar detalhes do Cliente. Retornando à listagem.",
			failedToGetOptions:
				"Falha ao buscar as opções disponíveis. Por favor, recarregue a página.",
			failedToGetTermList: "Falha ao buscar listagem de termos.",
			failedToGetTermDetails: "Falha ao buscar detalhes do Termo.",
			failedToGetTerm: "Falha ao buscar termo.",
			files: {
				noFileExt: "Tipo de arquivo não reconhecido",
				wrongFileExt: (acceptedFormats: string[]) =>
					`Arquivo deve ter um dos seguintes formatos: ${acceptedFormats.join(
						", "
					)}.`,
				fileSizeTooBig: (maxByteSize: number) =>
					`Tamanho do arquivo excede o máximo permitido (${
						maxByteSize / (1024 * 1024)
					}MB)`,
				uploadErrorMessage: "Não concluído. Você pode tentar novamente.",
				deleteErrorMessage:
					"Não foi possível deletar a imagem. Você pode tentar novamente",
				errorToAttach: "Erro ao anexar documento",
				tryAgain: "tentar upload novamente"
			}
		},
		success: {
			tenantAddedTitle: "Produto adicionado",
			tenantAddedMessage: (name: string) =>
				`O produto ${name} foi adicionado com sucesso.`,
			tenantUpdatedTitle: "Produto atualizado",
			tenantUpdatedMessage: (name: string) =>
				`O produto ${name} foi atualizado com sucesso.`,
			termAddedTitle: "Termo adicionado com sucesso.",
			termUpdatedTitle: "Termo atualizado com sucesso.",
			termCanceledTitle: "Termo cancelado com sucesso."
		},
		states: {
			AC: "Acre",
			AL: "Alagoas",
			AP: "Amapá",
			AM: "Amazonas",
			BA: "Bahia",
			CE: "Ceará",
			DF: "Distrito Federal",
			ES: "Espirito Santo",
			GO: "Goiás",
			MA: "Maranhão",
			MS: "Mato Grosso do Sul",
			MT: "Mato Grosso",
			MG: "Minas Gerais",
			PA: "Pará",
			PB: "Paraíba",
			PR: "Paraná",
			PE: "Pernambuco",
			PI: "Piauí",
			RJ: "Rio de Janeiro",
			RN: "Rio Grande do Norte",
			RS: "Rio Grande do Sul",
			RO: "Rondônia",
			RR: "Roraima",
			SC: "Santa Catarina",
			SP: "São Paulo",
			SE: "Sergipe",
			TO: "Tocantins"
		}
	};
	export const tabs: { [name: string]: Tab } = {
		[Tabs.TENANTS]: {
			title: "Produtos",
			baseUrl: "/backoffice/tenants",
			isNecessaryTenant: false,
			BaseListComponent: TenantList,
			BaseDetailsComponent: TenantDetails,
			BaseCreateComponent: NewTenant,
			BaseEditComponent: EditTenant
		},
		[Tabs.PARTNERS]: {
			title: "Parceiros",
			baseUrl: "/backoffice/partners",
			isNecessaryTenant: true,
			BaseListComponent: PartnerList,
			BaseDetailsComponent: PartnerDetails,
			BaseCreateComponent: undefined,
			BaseEditComponent: undefined
		},
		[Tabs.CUSTOMERS]: {
			title: "Clientes",
			baseUrl: "/backoffice/customers",
			isNecessaryTenant: true,
			BaseListComponent: CustomerList,
			BaseDetailsComponent: CustomerDetails,
			BaseCreateComponent: undefined,
			BaseEditComponent: undefined
		}
	};
	export const ACCESS_TOKEN_COOKIE = "access_token";
}
